module.exports = __webpack_public_path__ + "media/images/amenities_icons/sports_team-a9b509fc855c230719c15c3f65054860.svg";